export const hexToRgb = hex => {
    const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : null;
};

export const makeGradientFill = color => {
    const rgb = color && hexToRgb(color);
    if (!rgb) return "transparent";
    const [r, g, b] = rgb;
    return {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
            [0, `rgba(${r},${g},${b},0.4)`],
            [1, `rgba(${r},${g},${b},0)`]
        ]
    };
};
